import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { toast } from "sonner";
import { login } from "../services/auth.service";
import { saveAccessToken, saveRefreshToken } from "../utils/storage.utils";

export const useLogin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: login,
    onSuccess: async (data) => {
      // Save tokens to Office.js storage
      if (data.access_token) {
        await saveAccessToken(data.access_token);
      }

      if (data.refresh_token) {
        await saveRefreshToken(data.refresh_token);
      }

      // Invalidate user query to trigger refetch and navigate to authenticated screen
      queryClient.invalidateQueries({ queryKey: ["user"] });
    },
    onError: (error) => {
      console.error("Login failed:", error);

      // Extract error message from API response
      let errorMessage = "An error occurred during login. Please try again.";

      if (isAxiosError(error) && error.response?.data?.detail) {
        errorMessage = error.response.data.detail;
      } else if (error instanceof Error) {
        errorMessage = error.message;
      }

      // Show error toast
      toast.error(errorMessage);
    },
  });
};

export default useLogin;
